export default __webpack_public_path__ + "static/brand-colors-mic-annotation-light-17d1233f626075546ac1f4ad9101c6d6757a6767fbce0da491ac7f2365b92f1c.png";